import { Link } from 'react-router-dom';

const AboutUsHero = () => {
  return (
    <section className="relative h-screen min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/9fbe86de31d6ca16e58ba823ef34a1e6.jpg"
        alt="About Custom Clothiers — Bespoke Tailors in Wellesley MA since 1970"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/92 via-black/75 to-black/35"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm border border-[#C4A962]/50 rounded-full px-6 py-2.5 mb-8">
            <i className="ri-history-line text-[#C4A962] mr-2 text-sm"></i>
            <span className="text-white text-sm font-medium tracking-widest uppercase">Crafting Excellence Since 1970</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-none tracking-tight">
            The Story<br />Behind<br />
            <span className="text-[#C4A962]">Custom Clothiers</span>
          </h1>
          <p
            className="text-xl text-white mb-10 leading-relaxed"
            style={{ textShadow: '0 2px 12px rgba(0,0,0,0.9)' }}
          >
            For over 55 years, we have been Wellesley's most trusted bespoke tailors — building
            lasting relationships one perfectly fitted garment at a time.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="bg-[#C4A962] text-white px-9 py-4 rounded-lg text-lg font-semibold hover:bg-[#B39952] transition-all transform hover:scale-105 whitespace-nowrap text-center"
            >
              <i className="ri-calendar-line mr-2"></i>Book a Consultation
            </Link>
            <a
              href="tel:781-237-3166"
              className="bg-white/10 backdrop-blur-sm border border-white/30 text-white px-9 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap text-center"
            >
              <i className="ri-phone-line mr-2"></i>781-237-3166
            </a>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-5 max-w-md">
            {[
              { num: '55+', label: 'Years in Business' },
              { num: '3,500+', label: 'Happy Clients' },
              { num: '5,000+', label: 'Premium Fabrics' },
            ].map((s) => (
              <div key={s.label} className="bg-white/10 backdrop-blur-sm border border-white/15 rounded-2xl px-4 py-5 text-center">
                <p className="text-3xl font-bold text-[#C4A962] leading-none">{s.num}</p>
                <p className="text-gray-300 text-xs mt-2 leading-tight">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsHero;
